import { signal } from "@preact/signals-react"


export const priceKpi = signal(false)
export const includeProviders = signal(true)
export const mainSiteProvider = signal(false)
export const acrissCategory = signal(false)
// ACRISS_GROUP_BY.ACRISS_GROUP: the widest of the three, and the one that keeps the table
// readable — a column per acriss code is a lot of horizontal scroll to land on
export const acrissGroupBy = signal('acriss_group')
export const directSiteBrokerProvider = signal(false)
export const groupBy = signal('day')
export const dailyPrice = signal(false)
export const siteMarket = signal(false)